export default __webpack_public_path__ + "static/media/coinverter.37988322.png";